import React, { useId, useState, useEffect } from "react";
import {
  ChildContainer,
  Container,
} from "../../../../components/Container/Containers";
import styles from "./CustomerDetail.module.css";
// import NewCustomer from "../add/NewVFUser";
import IMAGES from "../../../../assets/images/images";
import { Banner } from "../../../../components/banner/Banners";
import NewUser from "../addUser/NewUser.container";
import { Field, Form, Formik,ErrorMessage,useFormik, useField } from "formik";
import * as Yup from "yup";
import { formatSecondsToDate } from "../../../../utils/dateTime";
import { Loader } from "../../../../components/loader/Loader";
// import { Alert } from "../../../../components/alert/alerts";
import { FUNCTIONAL_ROLES_CONSTANTS, USER_TYPE } from "../../../../utils/constants/userConstants";
import InfiniteScroll from "react-infinite-scroll-component";
import { EmptyContainer } from "../../../dashboard/graphs/component/component";
import { FormFieldLabel as Label ,FormErrorLabel as ErrorLabel} from "../../../../components/label/Labels";
import AddNewProduct from "./addNewProduct/addNewProduct";
import { headers as fincaheader,columnConfig, ServiceType, customerDetailcolumnConfig, accountmanagerDetailcolumnConfig, LIST_TYPE } from "../../../../utils/constants/userManagementConstant";
import DynamicTable from "../../../../components/dynamicTable/dynamicTable";
import Editmodule from "./addNewProduct/editmodule";
import AddAccountManager from "../addAccountManager/addAccountManager";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SectionGuard from "../../../../hoc/guards/SectionGuard";
import CAN from "../../../../casl/can";
import { Action, Resource } from "../../../../casl/constants";
import { Incident_Service_Type_Values, ivcOneITSMServiceNames } from "../../../../utils/constants/incidentConstants";
import can from "../../../../casl/can";
import { computeWeightedWidths, formatDate, sortByLabelAsc, useNotificationId } from "../../../../utils/arrayUtils";
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
import Table from "../../../../components/table/Table";
import ConfirmationPopup from "../../../../components/confirmationPopup/ConfirmationPopup";
import DropDown from "../../../../components/dropDown/DropDown";
import DetailsTooltip from "../../../../components/detailsTooltip/detailsTooltip";


const Switch = ({ isChecked,onClick,cursorstyle,reason }) => {
  // const logs = reason?.userStatusMetadata?.userInactivityLogs;
  // const reasonText = Array.isArray(logs) && logs.length > 0
  //   ? logs[logs.length - 1]?.reason || "Inactive"
  //   : "Inactive";  

    const logs = reason?.userStatusMetadata?.userInactivityLogs ?? [];
    const lastLog = logs.at(-1);
    const statusText = reason?.status ? reason?.status === "active" ? "Active" : "Inactive" :isChecked ? "Active" : "Inactive";
    const tooltipContent = logs.length > 0 ? (
      <DetailsTooltip
        data={{
          Status: lastLog?.status === "active" ? "Active" : "Inactive",
          [lastLog?.status === "active" ? "Activated By" : "Deactivated By"]: lastLog?.modifiedBy?.name,
          [lastLog?.status === "active" ? "Activated On" : "Deactivated On"]: formatDate(lastLog?.modifiedAt),
          Reason: lastLog?.reason,
        }}
      />
    ) : (
      statusText
    );
             
  return (
      <SecondaryTooltip text={ tooltipContent} customCss={"broadcastCss"} backgroundStyle={"backgroundStyle"} positions={['bottom', 'right','top']}>
    <label className={styles.switch}>
        <input type="checkbox" checked={isChecked}  onClick={onClick} />
        <span className={`${styles.slider} ${cursorstyle ? styles.pointer : styles.notAllowed}`}></span>
    </label>
      </SecondaryTooltip>
  );
};
const CheckBox = ({ name, value, label }) => {
  const id = useId();
  return (
    <div className={styles.radioField}>
      <Field
        id={id}
        className={styles.radioInput}
        type="checkbox"
        name={name}
        value={value}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};
const CheckBoxs = ({ name, value, label, onChange, checked }) => {
  const id = useId();
  return (
    <div className={styles.radioField}>
      <Field
        id={id}
        className={styles.radioInput}
        type="checkbox"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};

const UserList = ({ data, functionalRolesData, updateUserPermissions, openAlertPopup }) => {
  let [isAlert, setIsAlert] = useState(false);
  let [isEditPermission, setIsEditPermission] = useState(false);
  let [showLoader, setShowLoader] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    image: IMAGES.success,
  });

  const validationSchema = Yup.object().shape({
    functionalRoles: Yup.array().min(1),
  });
  let initialValues = {
    functionalRoles:
    data?.functionalRoles && data?.functionalRoles.length > 0 ? data?.functionalRoles : [],
  };

  const editPermission = () => {
    setIsEditPermission(!isEditPermission);
  };

  return (
    <div className={styles.CustomerContainer}>
      <div className={styles.CustomerList}>
        <span className={styles.spanlabel}>Contact Name</span>
        <p>{data?.displayName}</p>
      </div>

      <div className={styles.CustomerList}>
        <span className={styles.spanlabel}>Email Address</span>
        <p>{data.email}</p>
      </div>

      {/* <div className={styles.CustomerList}>
        <span className={styles.spanlabel}>Mobile Number</span>
        <p>{data.phoneNumber}</p>
      </div> */}

      <div className={styles.CustomerList}>
        <span className={styles.spanlabel}>Onboarded On</span>
        <p>{formatDate(data.createdAt)}</p>
      </div>

      <div className={styles.CustomerList}>
        <span className={styles.spanlabel}>Status </span>
        <p>
          {""}Inactive{" "}
          <span className={styles.spanSwitch}>
            <Switch isChecked={data.status === "active" ? true : false} />
          </span>
          Active
        </p>
      </div>
      <ExpandableArea>
        <div style={{ width: "100%" }}>
          <div>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={validationSchema}
              validateOnChange
              onSubmit={async (values, { resetForm }) => {
                values.userType = data.userType;
                setShowLoader(true);
                updateUserPermissions(values, data.uid)
                  .then((result) => {
                    if (result.status) {
                      setIsEditPermission(!isEditPermission);
                      // setMessage({
                      //   message: "User permissions updated successfully.",
                      //   image: IMAGES.success,
                      // });
                      // setIsAlert(true);
                      openAlertPopup({
                        message: "User permissions updated successfully!",
                        image: IMAGES.success
                      });
                      setShowLoader(false);
                    } else {
                      let error_msg = result?.error;
                      setIsEditPermission(!isEditPermission);
                      // setMessage({
                      //   message: error_msg,
                      //   image: IMAGES.error,
                      // });
                      // setIsAlert(true);
                      openAlertPopup({
                        message: error_msg,
                        image: IMAGES.success
                      });
                      setShowLoader(false);
                    }
                  })
                  .catch((error) => {
                    setIsEditPermission(!isEditPermission);
                    // setMessage({
                    //   message: "Something went wrong.",
                    //   image: IMAGES.error,
                    // });
                    // setIsAlert(true);
                    openAlertPopup({
                      message: "An error occurred while processing your request. Please try again later.",
                      image: IMAGES.error
                    });
                    setShowLoader(false);
                  });
              }}
            >
              {({ isValid, dirty, submitForm }) => (
                <Form className={styles.form}>
                  <div className={styles.sectionContainer}>
                    <div className={styles.sectionTitle}>Modules Assigned</div>
                    {showLoader ? (
                      <div className={styles.loaderContainer}>
                        <Loader style={styles.loaderContainer} />
                      </div>
                    ) : isEditPermission ? (
                      <div>
                        <img
                          src={IMAGES.save}
                          className={styles.Icon}
                          onClick={submitForm}
                        />
                      </div>
                    ) : (
                      <div>
                        <img
                          src={IMAGES.editIcon}
                          className={styles.Icon}
                          onClick={editPermission}
                        />
                      </div>
                    )}
                  </div>
                  <ul
                    style={{
                      listStyle: "none",
                      paddingInlineStart: 0,
                      display: "grid",
                      gap: 16,
                      gridTemplateColumns: "repeat(2, 1fr)",
                    }}
                  >
                    {functionalRolesData.map((role) => (
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <fieldset disabled={!isEditPermission}>
                          <CheckBox
                            name="functionalRoles"
                            value={role.id}
                            label={role.name}
                          />
                        </fieldset>
                      </li>
                    ))}
                  <ErrorMessage name ="functionalRoles">
                    {(msg)=><ErrorLabel text={msg} />}
                  </ErrorMessage>
                  </ul>
                  <div></div>
                  {/* {isAlert && (
                    <div
                      style={{
                        zIndex: 20,
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                      }}
                    >
                      <Alert
                        image={message.image}
                        message={message.message}
                        onClose={setIsAlert}
                      />
                    </div>
                  )} */}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </ExpandableArea>
    </div>
  );
};

const ExpandableArea = ({ children }) => {
  const [expanded, setExpanded] = useState(false);

  if (!expanded) {
    return (
      <div className={styles.expanded}>
        <button
          className={styles.transparentBtn}
          onClick={() => setExpanded(true)}
        >
          <span>View More</span>
          <img src={IMAGES.arrowdown} width={24} height={24} alt="down arrow" />
        </button>
      </div>
    );
  }

  return (
    <div className={styles.expanded}>
      <div>
        <button
          className={styles.transparentBtn}
          onClick={() => setExpanded(false)}
        >
          <span>View Less</span>
          <img src={IMAGES.arrowup} width={24} height={24} alt="up arrow" />
        </button>
      </div>

      {children}
    </div>
  );
};

const VodafoneUserList = ({ vfData }) => {
  return (
    <div className={styles.CustomerContainer}>
      <div className={styles.CustomerList}>
        <span className={styles.spanlabel}>
          {vfData?.pref == 0
            ? "Primary Contact Name"
            : "Additional Contact Name"}
        </span>
        <p>{vfData?.name}</p>
      </div>
      <div className={styles.CustomerList}>
        <span className={styles.spanlabel}>Email Address</span>
        <p>{vfData?.email}</p>
      </div>
      {/*<div className={styles.CustomerList}>
        <span className={styles.spanlabel}>Onboarded on</span>
        <p>22 May 2020</p>
      </div>
      <div className={styles.CustomerList}>
        <span className={styles.spanlabel}>Status </span>
        <p>
          Inactive{" "}
          <span className={styles.spanSwitch}>
            <Switch />
          </span>{" "}
          Active
        </p>
  </div>*/}
    </div>
  );
};

const CustomerDetail = ({
  customerId,
  customer,
  isLoadingCustomer,
  getDetails,
  onBack,
  myRights,
  next,
  ...props
}) => {
  const { userList, isLoading, functionalRoles, openAlertPopup } = props;
  const [showProduct, setShowProduct] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isIPXServicesChecked, setIsIPXServicesChecked] = useState(false);
  const [isInternationalVoiceServicesChecked,setIsInternationalVoiceServicesChecked] = useState(false);
   const [isSubmitActive, setIsSubmitActive] = useState(false);
  const [loadingUserId, setLoadingUserId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showFinca, setShowFinca] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOperatorCode, setSelectedOperatorCode] = useState('');
  const [fincaCode, setFincaCode] = useState('')
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [isEditOneItsmServiceName, setIsEditOneItsmServiceName] = useState(false);
  const [isSubmitOneItsmServiceName, setIsSubmitOneItsmServiceName] = useState(false);
  let { requestId } = useParams();
  const notificationId = useNotificationId();
  useEffect(() => {
    if (notificationId) {
      const payload = { read: true };
      props?.ReadNotification(payload,notificationId)
    }
  }, [notificationId]);
  const addFincacode =(e,setFieldValue)=>{
    e.preventDefault();
    setFieldValue("fincaTadigCode", fincaCode);
    setShowFinca(false);
  }
  const showFincaDetails = () => {
    setShowFinca(!showFinca);
    setSelectedOperatorCode('');
    setFincaCode('');
  }
  const handleSearchChange = (event) => {
    event.preventDefault()
    setSearchTerm(event.target.value);
  };
  const handleRowClick = (operatorCode) => {
    setSelectedOperatorCode(operatorCode)
  };
  const filteredData = props?.fincaTadig?.data?.filter((item) =>
    item?.fincaTADIG?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    item?.orgName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

const labeledOptions = filteredData?.map((item) => ({
  label: item.orgName,
  value: {
    "Operator Code":(item.fincaTADIG),
    "Operator Name":(item.orgName)
  }
}));
const mapdata = sortByLabelAsc(labeledOptions).map((option) => option.value);


  const addCode = (e, setFieldValue) => {
    e.preventDefault();
    setFieldValue("fincaTadigCode", selectedOperatorCode);
    setShowFinca(false);
  };

  const navigate = useNavigate();
  // const gotoDetail = (requestId) => {
  //   if(CAN(Action.GET, Resource.CUSTOMER_ONBOARDING_APPROVAL)){
  //     navigate(`/user-management/OnboardingDetail/${requestId}`);
  //   }else if(CAN(Action.GET, Resource.CUSTOMER_ONBOARDING_REQUEST)){
  //     navigate(`/user-management/OnboardingRequestDetail/${requestId}`);
  //   }
  // }
  const navigateRequestDetail = (requestId) => {
    if(CAN(Action.GET, Resource.CUSTOMER_ONBOARDING_APPROVAL)){
      return`/user-management/OnboardingDetail/${requestId}`
    }else if(CAN(Action.GET, Resource.CUSTOMER_ONBOARDING_REQUEST)){
      return `/user-management/OnboardingRequestDetail/${requestId}`
    }else{
      return '#'
    }
  }
  
  // const headers = ['Contact Name', 'Email Address', 'Onboarded On','Recent Activity Time','Last Updated On', 'Status'];
  // if (CAN(Action.CREATE, Resource.RIGHTS)) {
  //   headers.push('Edit Access');
  //    }
 
  const headers = [
      <div className={styles.organisationName} key="contactName">
        <div className={styles.orgname}>Contact Name</div>
      </div>,
      <div className={styles.organisationName} key="emailAddress">
        <div className={styles.orgname}>Email Address</div>
      </div>,
      <div className={styles.organisationName} key="onboardedOn">
        <div className={styles.orgname}>Added On</div>
      </div>,
      <div className={styles.organisationName} key="recentActivityTime">
        <div className={styles.orgname}>Recent Activity Time</div>
      </div>,
      <div className={styles.organisationName} key="lastUpdatedOn">
        <div className={styles.orgname}>Last Updated On</div>
      </div>,
      <div className={styles.organisationName} key="status">
        <div className={styles.orgname}>Status</div>
      </div>,
      ...(CAN(Action.CREATE, Resource.RIGHTS)
        ? [
          <div className={styles.organisationName} key="editAccess">
            <div className={styles.orgname}>Edit Access</div>
          </div>,
        ]
        : []),
    ]

  // Separate primary contacts and other users
const primaryContacts = userList?.filter(user =>
  customer?.serviceSpecificDetails?.some(entry =>
      entry.primaryContacts.some(contact => contact.email === user.email)
  )
) || [];
//Separate primary contacts and other users
const otherUsers = userList?.filter(user =>
  !customer?.serviceSpecificDetails?.some(entry =>
      entry.primaryContacts.some(contact => contact.email === user.email)
  )
) || [];

// Combine primary contacts with other users
const combinedUserList = [...primaryContacts, ...otherUsers];
 
const onSubmit = (isChecked,id,reason,email,setShowPopup,userToConfirm) => { 
  setIsSubmitActive(true); 
  setLoadingUserId(id); 
  const payload = {
    status: isChecked  ? "inactive" : "active",
    reason:reason,
  };
  props.SubmitActiveInactive(payload,id).then((result) => {
    if (result.status) {
      openAlertPopup({
        message: `${email} has been ${isChecked ? "deactivated" : "activated"} successfully!`,
        image: IMAGES.success,
      });
      setIsSubmitActive(false);
      setLoadingUserId(null);
      setShowPopup(false);
      const id = customerId || requestId;
    if (id) {
      if (userToConfirm?.listType === LIST_TYPE.CUSTOMER_LIST) {
        props.getUser(USER_TYPE.CUSTOMER, id, "", null);
      } else {
        getDetails(id);
      }
    }
    } else {
      let error_msg = result?.error?.message ?? "An error occurred while processing your request. Please try again later.";
      openAlertPopup({
        message: error_msg,
        image: IMAGES.error,
      //  isFormOpen:true
      });
      setIsSubmitActive(false);
     setLoadingUserId(null);
     setShowPopup(false);
    }
  })
  .catch((error) => {
    openAlertPopup({
      message: "An error occurred while processing your request. Please try again later.",
      image: IMAGES.error,
    //  isFormOpen:true
    });
    setIsSubmitActive(false);
  setLoadingUserId(null);
  setShowPopup(false);
  });
};

const handleOkClick = () => {
  setIsSubmit(true);
  const values = formValues;
  let obj = {fincaTadigCode: values.fincaTadigCode?.trim(),};
  props.SubmitFincaId(obj, customer?.uniqueCustomerRefId)
  .then((result) => {
    if (result.status) {
      props.openAlertPopup({
        message: "Customer details updated successfully!.",
        image: IMAGES.success,
      });
      setIsSubmit(false);
      setIsEditing(false);
      getDetails(customer?.uniqueCustomerRefId);
      setShowConfirmation(false);                
    } else {
      let error_msg = result?.error?.message ?? "An error occurred while processing your request. Please try again later.";
      props.openAlertPopup({message: error_msg,image: IMAGES.error,});
      setIsSubmit(false);
      setIsEditing(false);
      setShowConfirmation(false);
      }
    })
    .catch((error) => {
      props.openAlertPopup({message: "An error occurred while processing your request. Please try again later.",image: IMAGES.error,});
        setIsSubmit(false);
        setIsEditing(false);
        setShowConfirmation(false);
      });
};

const handleCancelClick = () => {
  setShowConfirmation(false);
  setIsSubmit(false)
};

const [showPopup, setShowPopup] = useState(false);
const [userToConfirm, setUserToConfirm] = useState(null);

const handleSwitchClick = (user, listType) => {
  if (CAN(Action.TOGGLE_USER_STATUS, Resource.RIGHTS) && user?.email !== myRights?.email) {
    setShowPopup(true);
    setUserToConfirm({user, listType});
  }
};

const handleConfirm = (reason) => {
  onSubmit(userToConfirm?.user?.status === 'active', userToConfirm?.user?.id,reason,userToConfirm?.user?.email,setShowPopup,userToConfirm);
};

const handleCancel = () => {
  setShowPopup(false);
};
  const mappedData = combinedUserList?.map(user => ({
    'contactName': <SecondaryTooltip text={user?.displayName} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{customer?.serviceSpecificDetails?.some(entry =>entry.primaryContacts.some(contact => contact.email === user.email))&&(<img className={styles.primary} src={IMAGES.primary} />)}{user?.displayName}</span></SecondaryTooltip>,
    'emailAddress':<SecondaryTooltip copy={true} text={user?.email} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{user?.email}</span></SecondaryTooltip>,
    'onboardedOn':<span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip text={formatDate(user?.createdAt)} positions={['bottom', 'right']}>{formatDate(user?.createdAt)}</SecondaryTooltip></span>,
    'recentActivityTime': <span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip text={user?.currentLoginTime?formatDate(user?.currentLoginTime):"Not Available"} positions={['bottom', 'right']}>{user?.currentLoginTime?formatDate(user?.currentLoginTime):"Not Available"}</SecondaryTooltip></span>, // Static value
    'lastUpdatedOn':<span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip text={user?.modifiedAt?formatDate(user?.modifiedAt):"Not Available"} positions={['bottom', 'right']}>{user?.modifiedAt?formatDate(user?.modifiedAt):"Not Available"}</SecondaryTooltip></span>,
    'status': 
    <p  className={styles.active}>
    {isSubmitActive && loadingUserId === user?.id ? 
      <Loader loaderStyle={styles.loaderStyleswitch} /> : 
    // <>{""}Inactive{" "}  
    <span className={styles.spanSwitch}>
  <Switch
      // cursorstyle={CAN(Action.TOGGLE_USER_STATUS, Resource.RIGHTS)}
      cursorstyle={user?.email!==myRights?.email}
      isChecked={user?.status === 'active'}
      reason={user}
      onClick={() => handleSwitchClick(user,LIST_TYPE.CUSTOMER_LIST)}
    />
     </span>
    // Active</>
  }
  </p>,
    'editAccess': 
    <SectionGuard canAccess={CAN(Action.CREATE, Resource.RIGHTS)}>
      <NewUser customerData={customer} userData={user} isEdit={true} icon={user?.status === "active" ? true : false}/>
    </SectionGuard>
  }));
  
  const accountManagerList = props?.accountManagerList;
  // Extract emails from mappedAccountManager

   const tableheaders = myRights.userType === USER_TYPE.INTERNAL
      ? [
        <div className={styles.organisationName} key="contactName"><div className={styles.orgname}>Contact Name</div></div>,
        <div className={styles.organisationName} key="emailAddress"><div className={styles.orgname}>Email Address</div></div>,
        <div className={styles.organisationName} key="assignedOn"><div className={styles.orgname}>Assigned On</div></div>,
        <div className={styles.organisationName} key="status"><div className={styles.orgname}>Status</div> </div>
      ]
      : [
        <div className={styles.organisationName} key="contactName"><div className={styles.orgname}>Contact Name</div></div>,
        <div className={styles.organisationName} key="emailAddress"><div className={styles.orgname}>Email Address</div></div>,
      ]

  let headerAccountManager = [];
  let mappedAccountManager = [];
  if (myRights.userType === USER_TYPE.INTERNAL) {
    // headerAccountManager = ['Contact Name', 'Email Address', 'Assigned On', 'Status'];
    const emailSet = new Set();
    mappedAccountManager = customer?.serviceSpecificDetails?.reduce((acc, detail) => {
      const managers = detail.accountManagers?.map(manager => {
        if (emailSet.has(manager.email)) {
          return null;
        }
        emailSet.add(manager.email);
        
        
      const matchedStatus = accountManagerList?.find(acc => acc.email === manager.email);
        return {
          'contactName': <SecondaryTooltip text={manager.name} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{manager.name}</span></SecondaryTooltip>,
          'emailAddress':<SecondaryTooltip copy={true} text={manager?.email} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{ manager.email}</span></SecondaryTooltip>,
          'assignedOn': <span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip text={formatDate(manager.onboardedDate)} positions={['bottom', 'right']}>{formatDate(manager.onboardedDate)}</SecondaryTooltip></span>,
          'status': (
            <p className={styles.active}>
              <span className={styles.spanSwitch}>
              <Switch 
                cursorstyle={false} 
                isChecked={matchedStatus?.status === 'active'} />
              </span>
            </p>
          ),
        };
      }).filter(manager => manager !== null) || [];
      return acc.concat(managers);
    }, []) || [];
  } else if (myRights.userType === USER_TYPE.CUSTOMER) {
    // headerAccountManager = ['Contact Name', 'Email Address'];
    const emailSet = new Set();
    mappedAccountManager = customer?.serviceSpecificDetails?.reduce((acc, detail) => {
      const managers = detail.accountManagers?.map(manager => {
        if (emailSet.has(manager.email)) {
          return null;
        }
        emailSet.add(manager.email);
        return {
          'contactName': <span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip text={manager.name} positions={['bottom', 'right']}>{manager.name}</SecondaryTooltip></span>,
          'emailAddress': <span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip copy={true} text={manager?.email} positions={['bottom', 'right']}>{manager.email}</SecondaryTooltip></span>
        };
      }).filter(manager => manager !== null) || [];
      return acc.concat(managers);
    }, []) || [];
  }

  const mappedAccountManagerData = customer?.serviceSpecificDetails[0]?.accountManagers?.map(manager => ({
    'contactName': <SecondaryTooltip text={manager.name} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{manager.name}</span></SecondaryTooltip>,
    'emailAddress': <SecondaryTooltip copy={true} text={manager?.email} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{manager.email}</span></SecondaryTooltip>,
    'assignedOn': <span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip text={formatDate(manager.onboardedDate)} positions={['bottom', 'right']}>{formatDate(manager.onboardedDate)}</SecondaryTooltip></span>,
    'status': ( 
      <>{myRights?.functionalRoles[0]==="super_admin_internal"? 
      <p className={styles.active}>
        {isSubmitActive && loadingUserId === manager?.id ?
          <Loader loaderStyle={styles.loaderStyleswitch} /> :
          <span className={styles.spanSwitch}>
            <Switch
              cursorstyle={true}
              isChecked={manager?.status === 'active'}
              reason={manager}
              onClick={() => handleSwitchClick(manager, LIST_TYPE.ACCOUNT_MANAGER_LIST)}
            />
          </span>}
      </p>:<div className={manager?.status ==='active'? styles.activestatus:styles.inactivestatus}>{manager?.status ==='active'?"Active":"Inactive"}</div>}
    </>),
  }));

 const mappedEmails = new Set(customer?.serviceSpecificDetails?.[0]?.accountManagers?.map(manager => manager.email));
 // Filter accountManagerList to include only those emails not present in mappedEmails

 const filteredAccountManager = accountManagerList?.filter(item => !mappedEmails.has(item.email))?.map(item => ({
   value: item.email,
   label: item.displayName,
    })) || [];

 // Log the filtered emails from accountManagerList
 filteredAccountManager.forEach(manager => {
   return {
      value: manager.email,
      label: manager.displayName,
   }
 });


  useEffect(() => {
    let searchKey = "";
    let type = USER_TYPE.CUSTOMER;
    let custID = customerId;
    let next=null;
    props.getAccountManagerList();
    if(customerId){
      props.getUser(type, custID, searchKey,next);
    }else if(requestId){
      props.getUser(type, requestId, searchKey,next);
    }
    props.getPredefinedRoles("customer");
    getDetails(customerId?customerId:requestId);
    if(CAN(Action.LIST, Resource.FINCA_TADIG)){
      props.getFincaTadig()
    }
    window.scrollTo(0,0);
    return () => {
      props.resetUserList();
  };
  }, [requestId]);

  const back=()=>{
    navigate(-1);
    // navigate("/user-management/customers")
  }

const SelectField = ({ title, options, isMandatory,customHeight, ...props }) => {
   let _options = options.map((item) => ({
   value: item.value,
   label: item.label,
   }));
   const [field, meta, helpers] = useField(props);
  
   const hasError = meta.touched && meta.error ? true : false;
   return (
   <div className={styles.fieldWrapper}>
   <DropDown
   style={{height:"28px"}}
   options={_options}
   customStyles={props.customStyles}
   onChange={({ label, value }) => {
   props.onChange(value);
   helpers.setValue(value);
   }}
   value={
   _options && field.value
   ? _options.find((option) => option.value === field.value)
   : ""
   }
   hasError={hasError}
   isDisabled={props.isDisabled}
  customHeight={customHeight}
   />
   {hasError ? <div className={styles.errorLabel}>{meta.error}</div> : null}
   </div>
   );
  };

  return (
    <Container>
       {showConfirmation && ( 
        <div className={styles.alertmessage}> 
          <div className={styles.cnfcontent}> 
            <div className={`${styles.popupheader}`}> 
              <div className={styles.confirmheader}>Verification Required</div>
            </div>
            <div className={styles.infomsgs}>
            Please verify the following details are correct for the Org. legal name <span className={styles.cnfmsg}>{`'${customer?.displayName}'`}</span> to ensure accuracy and avoid any discrepancies:
              {/* Kindly ensure <span className={styles.cnfmsg}>FinCA code</span> for  is correct to avoid any discrepancies: */}
              {/* <div className={styles.cnfparent}>
                  <div className={`${styles.fincaco} ${styles.bkcolor}`}>FinCA code</div>
                  <div className={`${styles.fincaval} ${styles.bkcolor}`}>{formValues.fincaTadigCode}</div>
              </div> */}
               <div className={styles.cfparent}>
                  <div className={`${styles.ipxcont} ${styles.bkcolor}`}>
                    <div className={styles.ipxcontlabel}>Invoice Code</div>
                    <div className={styles.ipxcontval}>{formValues.fincaTadigCode}</div>
                  </div>
               </div>
            </div>
            <div className={styles.confirmfooter}>
              <button className={styles.cancelButton} onClick={handleCancelClick}>Cancel</button>
              {!isSubmit?<button className={styles.okButton} onClick={handleOkClick}>Submit</button>:<div className={styles.cnfloader}><Loader/></div>}
            </div>
          </div> 
        </div> 
      )}
      {/* {myRights.userType === USER_TYPE.CUSTOMER ? ( */}
        <Banner image={IMAGES.vfbanner} text={"Customer Details"}></Banner>
      {/* ): null} */}
      {isLoadingCustomer  ? (
        <Loader />
      ) : (
        <ChildContainer>
          <div className={styles.customer}>
            {myRights.userType === USER_TYPE.INTERNAL  ? (
              <img
                className={styles.icon}
                onClick={customerId?onBack:back}
                src={IMAGES.backarrow}
                alt=""
              />
            ) : null}
            <div className={styles.headtext}><SecondaryTooltip text={customer?.displayName} positions={['bottom', 'right']}><span className={`${styles.textCustomer} ${styles.valueText}`}>{customer?.displayName}</span></SecondaryTooltip></div>
          </div> 
          <div>
            <div className={styles.CustomerContainers}>
            <div className={styles.requestDetail}>Customer Details</div>
            <div  className={styles.Customerbox}>
              <div className={styles.CustomerListdata}>
                <div className={styles.spanlabel}>Organisation Legal Name</div>
                <SecondaryTooltip text={customer?.displayName} positions={['bottom', 'right']}><div className={`${styles.value} ${styles.valueText}`}>{customer?.displayName}</div></SecondaryTooltip>
              </div>
             
              </div>
              <div className={styles.requestDetail}>Availed Service</div>
              {customer?.serviceSpecificDetails?.map((detail,index, array)=>
      <div className={`${array.length > 1 && index !== array.length - 1 ? styles.borderbottom : ''}`}>
        <div key={index} className={`${styles.Customerbox}`} >
        <div className={styles.CustomerList}>
                <span className={styles.spanlabel}>Service Type</span>
                <p>{detail?.serviceType?.label}</p>
              </div>
              {detail?.cpName!==null&&(
                 <div className={styles.CustomerList}>
                 <div className={styles.spanlabel}>TADIG Code</div>
                 <SecondaryTooltip text={detail?.cpName} positions={['bottom', 'right']}><p className={`${styles.valueText}`}>{detail?.cpName}</p></SecondaryTooltip>
               </div>
              )}
      {detail?.serviceType?.value === Incident_Service_Type_Values.IPX_Service && myRights.userType===USER_TYPE.INTERNAL && (
  <div className={styles.CustomerList}>
    {(myRights.userType === USER_TYPE.INTERNAL && CAN(Action.UPDATE, Resource.CUSTOMERS) && CAN(Action.LIST, Resource.FINCA_TADIG))?
    <>{detail?.fincaTadigCode?<></>:<span className={styles.statusLegendsIcon}></span>}
    <span className={styles.spanlabel}>Invoice Code</span></>:<span className={styles.spanlabel}>Invoice Code</span>}
    {myRights.userType !== USER_TYPE.CUSTOMER ? (
  <>
    {isEditing ? (
      <Formik
        initialValues={{ fincaTadigCode: detail?.fincaTadigCode || null }}
        onSubmit={(values) => {
          setFormValues(values);
          setShowConfirmation(true);
          // setIsSubmit(true);
          // let obj = {
          //   fincaTadigCode: values.fincaTadigCode,
          // };
          // props.SubmitFincaId(obj, customer?.uniqueCustomerRefId)
          //   .then((result) => {
          //     if (result.status) {
          //       props.openAlertPopup({
          //         message: "Customer details updated successfully!.",
          //         image: IMAGES.success,
          //       });
          //       setIsSubmit(false);
          //       setIsEditing(false);
          //       getDetails(customerId);                
          //     } else {
          //       let error_msg = result?.error?.message ?? "Something went wrong.";
          //       props.openAlertPopup({
          //         message: error_msg,
          //         image: IMAGES.error,
          //       });
          //       setIsSubmit(false);
          //       setIsEditing(false);
          //     }
          //   })
          //   .catch((error) => {
          //     props.openAlertPopup({
          //       message: "Something went wrong.",
          //       image: IMAGES.error,
          //     });
          //     setIsSubmit(false);
          //     setIsEditing(false);
          //   });        
        }}
      >
        {({ dirty, isValid,values, setFieldValue }) => (
          <Form>
            <Field
              name="fincaTadigCode"
              placeholder="Enter here"
              className={styles.input}
            />
            <div className={styles.iconimg}>
             <span className={styles.iconparent} onClick={showFincaDetails}>
             <SecondaryTooltip text={<span>If you are unaware of the customer's Invoice code or wish to select from an existing list, please click on the icon
              <img className={styles.questionmark} src={IMAGES.questionicon} alt="Help" style={{ marginLeft: '2px' }} />.</span>}positions={['bottom', 'right']}>
              <img className={styles.questionicon} src={IMAGES.questionicon} alt="" />
            </SecondaryTooltip>
             </span>
             {showFinca && ( 
        <div className={styles.alertmessage}> 
         <div className={styles.alertcontent}> 
          <div className={`${styles.popupheader}`}> 
            <div className={styles.headertext}>Add Invoice Code</div>
            <img className={styles.close} src={IMAGES.close} alt="Close"   onClick={showFincaDetails}/> 
          </div>
          <div className={styles.infomsg}>
          {/* <span className={styles.childinfo}>The <span className={styles.boldtext}>FinCA code</span> is a unique identifier generated by the FinCA system.</span> */}
          <span className={styles.childinfo}>To add a Invoice code for a customer, search by Operator Name/Operator code or select from the list below, then click the <span className={styles.boldtext}>Add Code</span> button.</span>
          </div>
          <div className={styles.inputfieldcontainer}>
            <input
              type="text"
              placeholder="Search by Operator Code or Name..."
              value={searchTerm}
              onChange={handleSearchChange}
              className={styles.searchInput}
            />
            <div className={styles.searchwrapper}>
              <img className={styles.serchimage} src={IMAGES.searchimage} alt="Search" />
            </div>
          </div>
          <div className={styles.tableparent}>
              <Table
                headers={fincaheader}
                data={mapdata}
                maxHeight="300px"
                width="100%"
                columnConfig={columnConfig}
                nodata="No Code Found"
                onRowClick={handleRowClick}
                isClisk = {true}
              />
          </div>
          {mapdata?.length===0&&(
            <>
              <div className={styles.nodataintable}>
                <span className={styles.fincamsg}>You can enter the code for <span className={styles.searchTerm}> {customer?.displayName}</span>. If you don’t have the code, kindly contact the team</span>
              </div>
              <div className={styles.fincainput}>
                <label className={styles.fincalabel}>Invoice Code</label>
                <input
                  type="text"
                  placeholder="Enter Invoice code"
                  value={fincaCode}
                  onChange={(e) => setFincaCode(e.target.value)}
                  className={styles.textinput}
            />
              </div>
            </>
          )}
          <div className={styles.footerfinca}>
          {mapdata?.length===0?<button className={`${styles.addcode} ${fincaCode?.trim()===""?styles.disablebgtn:""}`} disabled={fincaCode?.trim()===""} onClick={(e)=>{addFincacode(e,setFieldValue)}}>Add Code</button>:
          <button className={`${styles.addcode} ${selectedOperatorCode?.trim()===""?styles.disablebgtn:""}`} disabled={selectedOperatorCode?.trim()===""} onClick={(e)=>{addCode(e,setFieldValue)}}>Add Code</button>}
          </div>
         </div> 
        </div> )}
             {isSubmit ? 
            <Loader loaderStyle={styles.loaderStyle}/>:
            <>
            <button
            //  disabled={!dirty}
              type="submit"
              className={`${styles.saveButton} ${styles.submitbtn} ${detail?.fincaTadigCode?styles.submitbutton:""} ${(values.fincaTadigCode==="" || values.fincaTadigCode===null)?styles.disablesavebtn:""}`}
              disabled={values.fincaTadigCode==="" || values.fincaTadigCode===null}
            >
              {(values.fincaTadigCode===""||values.fincaTadigCode===null)?<img src={IMAGES.disablesave} className={styles.disablesavebtn} alt="Save" />:<SecondaryTooltip text={"Click to save code"} positions={['bottom', 'right']}><img src={IMAGES.save} alt="Save" /></SecondaryTooltip>}
            </button>
            {isEditing&&<span className={styles.reseticonparent}><SecondaryTooltip text={"Click to cancel"} positions={['bottom', 'right']}><img src={IMAGES.closeicon} className={styles.reseticon} alt="Save" onClick={()=>{setIsEditing(false);}} /></SecondaryTooltip></span>}
            </> }
            </div>
          </Form>
        )}
      </Formik>
    ) : (
      <>
        <span className={styles.inputvalue}>{(detail?.fincaTadigCode ===null||detail?.fincaTadigCode===""|| !detail?.hasOwnProperty("fincaTadigCode")) ? <span className={styles.notadded}>Code Not Added</span>:<SecondaryTooltip text={detail?.fincaTadigCode} positions={['bottom', 'right']}><div className={`${styles.valueText}`}>{detail?.fincaTadigCode}</div></SecondaryTooltip>}</span>
        <SectionGuard canAccess={CAN(Action.UPDATE, Resource.CUSTOMERS)}>
          <SecondaryTooltip text={"Click to add code"} positions={['bottom', 'right']}>
           {detail?.fincaTadigCode?<img className={styles.editbtn} src={IMAGES.editrole} onClick={() => setIsEditing(true)}/>:<img className={styles.editbtn} src={IMAGES.addicon} onClick={() => setIsEditing(true)}/>}
          </SecondaryTooltip>
         </SectionGuard>
      </>
    )}
  </>
) : (
  <SecondaryTooltip text={detail?.fincaTadigCode ? detail?.fincaTadigCode : '---'} positions={['bottom', 'right']}><p className={`${styles.valueText}`}>{detail?.fincaTadigCode ? detail?.fincaTadigCode : '---'}</p></SecondaryTooltip>
)}
  </div>
)}
              {detail?.serviceType?.value===Incident_Service_Type_Values.IVC_Service&& myRights.userType!==USER_TYPE.CUSTOMER&&(
                <>
                  <div className={styles.CustomerList}>
                   <span className={styles.spanlabel}>Account Number</span>
                   <p>{detail?.accountNumber}</p>
                  </div>
                  <div className={styles.CustomerList}>
                   <span className={styles.spanlabel}>Account Abbreviation</span>
                   <p spandata>{detail?.accountAbbr}</p>
                  </div>
                </>
                )}
                {detail?.serviceType?.value===Incident_Service_Type_Values.IVC_Service&&(
                  <>
                   {(CAN(Action.UPDATE, Resource.CUSTOMERS) || CAN(Action.EDIT, Resource.CUSTOMERS))?
                   <div className={styles.CustomerList}>
                   <div className={`${styles.spanlabel}`}>{detail?.oneITSMAccountServiceName?<></>:<span className={styles.statusLegendsIcon}></span>}IVC Service Name  
                   {!isEditOneItsmServiceName?<SecondaryTooltip text={"Click to add Name"} positions={['bottom', 'right']}>{detail?.oneITSMAccountServiceName?<img className={styles.editbtn} src={IMAGES.editrole} onClick={() => setIsEditOneItsmServiceName(true)}/>:<img className={styles.editbtn} src={IMAGES.addicon} onClick={() => setIsEditOneItsmServiceName(true)}/>}
                   </SecondaryTooltip>:""}
                   </div>
                   {isEditOneItsmServiceName ? (
                    <Formik
                    initialValues={{ oneITSMAccountServiceName: detail?.oneITSMAccountServiceName}}
                    onSubmit={(values) => {
                      setIsSubmitOneItsmServiceName(true);
                      let obj = {
                        oneITSMAccountServiceName: values?.oneITSMAccountServiceName.trim(),
                      };
                      props.addOneItsmServiceName(obj, customer?.uniqueCustomerRefId)
                      .then((result) => {
                        if (result.status) {
                          props.openAlertPopup({
                            message: "Customer details updated successfully!.",
                            image: IMAGES.success,});
                            setIsSubmitOneItsmServiceName(false);
                            setIsEditOneItsmServiceName(false);
                            getDetails(customer?.uniqueCustomerRefId);
                          } else {
                            let error_msg = result?.error?.message ?? "An error occurred while processing your request. Please try again later.";
                            props.openAlertPopup({
                              message: error_msg,
                              image: IMAGES.error,
                            });
                            setIsSubmitOneItsmServiceName(false);
                            setIsEditOneItsmServiceName(false);
                          }
                        })
                        .catch((error) => {
                          props.openAlertPopup({
                            message: "An error occurred while processing your request. Please try again later.",
                            image: IMAGES.error,});
                            setIsSubmitOneItsmServiceName(false);
                            setIsEditOneItsmServiceName(false);
                          });
                        }}
                        >
                          {({ dirty, isValid,values, setFieldValue }) => (
                            <Form>
                              <div className={styles.oneitsmdropdown}>
                               <SelectField
                                    name="oneITSMAccountServiceName"
                                    options={ivcOneITSMServiceNames}
                                    value={values.oneITSMAccountServiceName}
                                    onChange={(value) => {setFieldValue('oneITSMAccountServiceName', value);}}
                                    placeholder="Select service name"
                                    additionalStyle={styles.additionalStyle}
                                    customHeight={30}
                                    />
                                  <div className={styles.btnwrapper}>
                                  {!isSubmitOneItsmServiceName?
                                  <button 
                                  type="submit" 
                                  className={`${styles.submitoneitsmButton} ${detail?.oneITSMAccountServiceName&&styles.submitoneitsmBtn}`}
                                  disabled={!dirty || !isValid || values.oneITSMAccountServiceName === detail?.oneITSMAccountServiceName}>
                                  {(values.oneITSMAccountServiceName !== detail?.oneITSMAccountServiceName&&values?.oneITSMAccountServiceName) ?<SecondaryTooltip text={"Click to save name"} positions={['bottom', 'right']}><img className={styles.saveoneitsmbtn} src={IMAGES.save} alt="Save" /></SecondaryTooltip>:<img src={IMAGES.disablesave} className={styles.disableoneitsmbtn} alt="Save" />}</button>:<div className={`${styles.itsmloader} ${styles.itsmload}`}><span className={styles.itsmloadericon}><Loader/></span></div>}
                                  {isEditOneItsmServiceName&&!isSubmitOneItsmServiceName&&<span className={styles.reseoneitsmparent}><SecondaryTooltip text={"Click to cancel"} positions={['bottom', 'right']}><img src={IMAGES.closeicon} className={styles.reseoneitsm} alt="Save" onClick={()=>{setIsEditOneItsmServiceName(false);}} /></SecondaryTooltip></span>}
                                  </div>
                              </div>
                            </Form>
                            )}
                        </Formik>)
                        :<p spandata>{detail?.oneITSMAccountServiceName?detail?.oneITSMAccountServiceName:<span className={`${styles.notadded} ${(!detail?.oneITSMAccountServiceName||detail?.hasOwnProperty("oneITSMAccountServiceName"))&&styles.marginfromleft}`}>Name Not Added</span>}</p>}
                   </div>
                  :<div className={styles.CustomerList}>
                    <div className={styles.spanlabel}>IVC Service Name</div>
                    <p spandata>{detail?.oneITSMAccountServiceName?detail?.oneITSMAccountServiceName:"---"}</p>
                  </div>}
                  </>
                )}
               <div className={styles.CustomerList}>
                <span className={styles.spanlabel}>Requested On</span>
                <p spandata>{customer?.requestedOn ? formatDate(customer?.requestedOn): "---"}</p>
              </div>
              <div className={styles.CustomerList}>
                <div className={styles.spanlabel}>Approved By</div>
                <SecondaryTooltip copy={true} text={detail?.approvedBy?.email} positions={['bottom', 'right']}><p className={`${styles.valueText}`}>{detail?.approvedBy?.name}</p></SecondaryTooltip>
              </div>
              <div className={styles.CustomerList}>
                <span className={styles.spanlabel}>Approved On</span>
                <p spandata>{formatDate(detail?.approvedAt)}</p>
              </div>
        </div>
        {detail?.serviceType?.value === Incident_Service_Type_Values.IPX_Service && !detail?.fincaTadigCode &&
        <SectionGuard canAccess={CAN(Action.UPDATE, Resource.CUSTOMERS)}>
          <div className={styles.parentdec}>
          <div className={styles.fincadesc}>
            <div><span className={styles.statusLegendsIcon}></span></div>
            <div>
              <span className={styles.decstext}>We have observed that the <span className={styles.boldtext}>Invoice code</span> has not been added for this customer, resulting in the inability to view or download their invoices. To rectify this, please click the <img className={styles.editbutton} src={IMAGES.addicon}/>  icon and take the necessary action to add the Invoice code.</span>
              {/* <span className={styles.decstext} style={{display:'block'}}>If you are unaware of the customer's Invoice code or wish to select from an existing list, please click on the icon  <img className={styles.questionmark} src={IMAGES.questionicon} alt="" />.</span> */}
            </div>
          </div>
          </div>
         </SectionGuard>}
         {detail?.serviceType?.value === Incident_Service_Type_Values.IVC_Service && !detail?.oneITSMAccountServiceName &&
        <SectionGuard canAccess={CAN(Action.UPDATE, Resource.CUSTOMERS)}>
          <div className={styles.parentdec}>
          <div className={styles.fincadesc}>
            <div><span className={styles.statusLegendsIcon}></span></div>
            <div>
              <span className={styles.decstext}>We have observed that the <span className={styles.boldtext}>IVC service name</span> has not been added for this customer, resulting in the inability to raise fault tickets To rectify this, please click the <img className={styles.editbutton} src={IMAGES.addicon}/>  icon and take the necessary action to add the IVC service name.</span>
            </div>
          </div>
          </div>
         </SectionGuard>}
        {
          detail?.requestDocumentId ?
            <SectionGuard canAccess={CAN(Action.GET, Resource.CUSTOMER_ONBOARDING_APPROVAL) || CAN(Action.GET, Resource.CUSTOMER_ONBOARDING_REQUEST)}>
              <div className={styles.linkdiv}> <Link to={navigateRequestDetail(detail?.requestDocumentId)} className={styles.linkgoto}>View Request Details</Link></div>
            </SectionGuard> : null
        }
      </div>
         )}
              {/* <div  className={styles.Customerbox}>
              <div className={styles.CustomerList}>
                <span className={styles.spanlabel}>TADIG ID</span>
                <p>{customer?.cpName}</p>
              </div>
              <div className={styles.CustomerList}>
                <span className={styles.spanlabel}>Onboarding Date</span>
                <p>{formatSecondsToDate(customer?.createdAt)}</p>
              </div>
              <div className={styles.CustomerList}>
                <span className={styles.spanlabel}>Primary Contact Name</span>
                <p spandata>{customer?.primaryContact?.displayName}</p>
              </div>
              <div className={styles.CustomerList}>
                <span className={styles.spanlabel}>Email Address</span>
                <p spandata>{customer?.primaryContact?.email}</p>
              </div>
              </div> */}
              <div className={styles.checkboxmain}>
                {/* <Formik
                 initialValues={{ services: [] }}
                >
                  {({ values, setFieldValue }) => (
                    <Form>
                      <div  className={styles.checkboxdiv}>
                      <div className={styles.checkboxipx}>
                        <CheckBoxs
                          name="servicesipx"
                          value={ServiceType.IPX_Services}
                          label="IPX Services"   
                          onChange={(e) => handleCheckboxChange(e, setFieldValue, values)}                 
                          checked={values.services.includes(ServiceType.IPX_Services)}
                        />
                      </div>
                      <div>
                        <CheckBoxs
                          name="servicesivc"
                          value={ServiceType.International_Voice_Services}
                          label="International Voice Services"
                          onChange={(e) => handleCheckboxChange(e, setFieldValue, values)}
                        checked={values.services.includes(ServiceType.International_Voice_Services)}
                        />
                        </div></div>
                        <div className={styles.headnote}>International Voice Services details are pending. Kindly fill up the details to extend the service for customer.</div>
                    
                    </Form>
                  )}
                </Formik> */}
                {/* {showProduct && <AddNewProduct source={"ipx"} open={setShowProduct}  serviceType={serviceType} 
               isIPXServicesChecked={isIPXServicesChecked} isInternationalVoiceServicesChecked={isInternationalVoiceServicesChecked}/> } */}
               {/* {myRights?.userType==USER_TYPE.INTERNAL && customer?.serviceSpecificDetails?.length<=1&& (  
                customer?.requestedByOnboarding?.some((item) => item?.email === myRights?.email) 
                ? <span className={styles.raisedreq}>A request has already been raised for {customer?.serviceSpecificDetails[0]?.serviceType?.value==="ipx_service"?"IVC":"IPX"}.</span>
                : <AddNewProduct serviceType={customer?.serviceSpecificDetails[0]?.serviceType} customerId={customer?.uniqueCustomerRefId} />
               )} */}
              </div>
  
            </div>
          </div>

          <div
            data-vf-user={
              myRights.userType === USER_TYPE.INTERNAL ? true : false
            }
            className={styles.detailsContainer}
          >
            <div>
            <div className={styles.alignbtns}>
              <div className={styles.textuser}>Account Manager </div>
              {myRights?.functionalRoles[0] === FUNCTIONAL_ROLES_CONSTANTS["super_admin_internal"]?.value &&(

                <AddAccountManager  customerData={customer}  filteredAccountManager={filteredAccountManager}/>)}
              </div>
             {/* <div className={styles.sharedEmailContainer}>
              <div className={styles.CustomerList}>
                <span className={styles.spanlabel}>Shared Mailbox</span>
                <p>{customer?.vfSharedMailDL}</p>
              </div>
            </div> */}
              {/* {customer?.vfPOC.map((vfData) => (
                <VodafoneUserList vfData={vfData} />
              ))} */}
                {/* {mappedAccountManager?.length>0?(
                 <DynamicTable headers={headerAccountManager} data={mappedAccountManager} className="custom-table" userType={myRights.userType} />
                ):<EmptyContainer>No Account Manager Found</EmptyContainer>}  */}
                  <Table headers={tableheaders} data={mappedAccountManagerData}  width="100%" columnConfig={computeWeightedWidths(customerDetailcolumnConfig)} isWidth={true} nodata={!isLoading && mappedAccountManagerData?.length===0?"No Data.":""} />                                 
            </div>
            <div>    

              <div className={styles.header}>            
                <div  className={styles.text}>
                Customer Contacts
                </div >               
                 <div className={styles.alignbtn}>
                 <NewUser customerData={customer} isEdit={false}/>
                </div>              
              </div>
              { userList?.length ? (
                <InfiniteScroll
                  dataLength={userList?.length} //This is important field to render the next data
                  next={() => {
                    return props.getUser(
                     USER_TYPE.CUSTOMER,
                     customerId?customerId:requestId,
                      "",
                      next
                    );
                  }}
                  hasMore={next}
                  loader={
                      <Loader />
                  }
                >
                  <div className={styles.tabel}>
                   {/* <DynamicTable headers={headers} data={mappedData} className="custom-table" /> */}
                     <Table headers={headers} data={mappedData}  width="100%" columnConfig={computeWeightedWidths(accountmanagerDetailcolumnConfig)} isWidth={true} nodata={!isLoading && mappedData?.length===0?"No Data.":""} /> 
                   <div className={styles.primarylabel}><img className={styles.primary} src={IMAGES.primary} />First Onboarded Primary Customer Contact.</div>
                   </div>
                  {/* {userList?.map((userData) => (
                    console.log("userData",userData),
                    
                    <UserList
                      data={userData}
                      functionalRolesData={functionalRoles}
                      updateUserPermissions={props.updateUserPermissions}
                      openAlertPopup= {openAlertPopup}
                    />
                  ))} */}
                </InfiniteScroll>
              ) : (
                // <div className={styles.emptyContainer}>No users found</div>
                <EmptyContainer>No User Found</EmptyContainer>
              )}
            </div>
            {showPopup && (
      <ConfirmationPopup
        header={"Status Update"}
        isSubmitActive={isSubmitActive}
        status={userToConfirm?.user?.status ==='active'? 'Inactive': "Active"}
        data={<span>Do you wish to change status to <span className={styles.popupmsg}>{userToConfirm?.user?.status ==='active'? 'Inactive': "Active"}</span> for <span className={styles.popupmsg}>{userToConfirm?.user?.displayName || userToConfirm?.user?.name}</span>?</span>}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    )}
          </div>
        </ChildContainer>
      )}
    </Container>
  );
};

export default CustomerDetail;
